// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ZxTU","selects":"Documents_selects__2XyMT"};